import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import WrapperOrders from "../../../components/shared/WrapperContent";
import OrdersContent from "../../../components/orders/content";
import style from "./OrderSearchPage.module.scss";
import { Expeditor, Order, User } from "../../../services";
import Loading from "../../../components/shared/Loading/Loading";
import EmptyContent from "../../../components/shared/emptyContent";
import { useSelector } from "react-redux";
import OrdersTable from "../../../components/orders-new/available/components/OrdersTable";
import HeaderContentNew from "../../../components/shared/HeaderContentNew/HeaderContentNew";
import OrderFilter from "../../../components/orders-new/filter";
import DefaultPaginationNew from "../../../components/shared/DefaultPaginationNew";
import moment from "moment";

const ITEMS_LIMIT = 10;

const OrderSearchPage = () => {
  const { t } = useTranslation();
  const [orders, setOrders] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const { user } = useSelector((state) => state);

  // pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [ordersTotal, setOrdersTotal] = useState(0);
  const [selectedLimit, changeLimit] = useState(10);

  const [forceUpdate, setForceUpdate] = useState(0);

  const [activeTap, setActiveTap] = useState("all");
  const [activeStatuses, setActiveStatuses] = useState([]);
  const [orderCounts, setOrderCounts] = useState({});

  // filter
  const [orderNumber, setOrderNumber] = useState("");
  const [cities, setCities] = useState([]);
  const [cityFrom, setCityFrom] = useState("");
  const [cityTo, setCityTo] = useState("");
  const [loadingDate, setLoadingDate] = useState("");
  const [unloadingDate, setUnloadingDate] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  
  const getOrders = () => {
    setLoading(true);

    const data = {
      currentPage,
      selectedLimit,
    };

    Expeditor.getPublishedOrders(
      currentPage, 
      ITEMS_LIMIT,
      orderNumber ? orderNumber : "",
      cityFrom ? cityFrom.id : "",
      cityTo ? cityTo.id : "",
      loadingDate ? moment(loadingDate).format("YYYY-MM-DD") : "",
      unloadingDate ? moment(unloadingDate).format("YYYY-MM-DD") : "",
    )
      .then((res) => res.data)
      .then((response) => {
        setOrders(response.rows);
        setOrdersTotal(response.total);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => setLoading(false));
  };

  // const currentOrderProps = useMemo(() => getOrderProps(activeTap), [activeTap]);

  const handleRefetchData = () => {
    setOrders([]);
    getOrders();
    // setCallTaps(!isCallTaps);
  };

  useEffect(() => {
    const delayFetch = setTimeout(() => {
      handleRefetchData();
    }, 500);
  
    return () => clearTimeout(delayFetch);
  }, [cityFrom, cityTo, loadingDate, unloadingDate, orderNumber]);

  useEffect(() => {
    // getOrderCounts();
    getOrders(activeStatuses, activeTap);
  }, [currentPage, forceUpdate, activeTap]);

  
  const getPropsFilter = () => ({
    orderNumber,
    setOrderNumber,
    cities,
    cityFrom,
    setCityFrom,
    cityTo,
    setCityTo,
    loadingDate,
    setLoadingDate,
    unloadingDate,
    setUnloadingDate,
    selectedStatus,
    setSelectedStatus,
  });

  useEffect(() => {
    Order.getAllCities()
      .then((res) => res.data)
      .then((data) => {
        const cities = data?.sort((a, b) => a.name.localeCompare(b.name));
        setCities(cities);
      })
      .catch((error) => {
        console.error("Error getting cities:", error);
      });
  }, []);

  if (user.type !== "Expeditor") {
    return (
      <div className="alert alert-warning text-center" role="alert">
        <strong>{t('common.warning')}</strong> {t('ordersSearch.errors.pageNotAvailable')}
      </div>
    );
  }

  return (
    <>
      <HeaderContentNew
        title={t('ordersSearch.pageTitle')}
        displayReloadBtn
        onReload={handleRefetchData}
      />

      <OrderFilter onRefetchData={handleRefetchData} {...getPropsFilter()} isShowStatus={false} />

      <WrapperOrders>
        <OrdersContent>
          <div className={style.content}>
            {isLoading ? (
              <Loading inBlock />
            ) : !orders.length && !isLoading ? (
              <EmptyContent />
            ) : (
              <>
                <OrdersTable
                  items={orders || []}
                  isLoading={false}
                  companyName={user?.companyName}
                  userType={user?.type}
                  user={user}
                  onForceUpdate={() => {
                    setForceUpdate((prev) => prev + 1);
                  }}
                  isShowOrderSolution
                  isSearchPage
                />
              </>
            )}
          </div>

          {orders && orders.length ? (
            <DefaultPaginationNew
              total={ordersTotal}
              currentPage={currentPage}
              limit={selectedLimit}
              changePage={setCurrentPage}
              changeLimit={changeLimit}
            />
          ) : null}
        </OrdersContent>
      </WrapperOrders>
    </>
  );
};

export default OrderSearchPage;
